import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-plan-selected-dialog',
  templateUrl: './plan-selected-dialog.component.html',
  styleUrls: ['./plan-selected-dialog.component.css']
})
export class PlanSelectedDialogComponent implements OnInit {

  emailAddress: string = '';

  constructor(public router: Router) {
    this.emailAddress = localStorage.getItem('emailAddress');
   }

  ngOnInit(): void {
  }

  logOut() {
    localStorage.removeItem('RenewalKey');
    localStorage.removeItem('emailAddress');
    this.router.navigate(['renewalcog/renewal-dashboard']);
  }

}
